module.exports = __webpack_public_path__ + "static/media/Logo single beta.2f932ab3.svg";